import { useTagSuggest } from "@web/components/tag/use-tag-suggest";
import { memo, useCallback } from "react";
import { useFormContext } from "react-hook-form";
import { useTagBox } from "./TagBox";

export const TagButton = memo(function TagButton() {
  const { getValues, setValue } = useFormContext();
  const { onChange, inputRef } = useTagBox();
  const suggest = useTagSuggest();

  const appendHashToTagline = useCallback(() => {
    try {
      const currentTagline = getValues("tagline") ?? "";
      const trimmedTagline = currentTagline.trimEnd();

      // Add hashtag if not already present
      const updatedTagline = trimmedTagline.endsWith("#")
        ? trimmedTagline
        : `${trimmedTagline}${trimmedTagline ? " " : ""}#`;

      // Update form and TagBox
      setValue("tagline", updatedTagline);
      onChange(updatedTagline);
      suggest("");

      // Focus input and move cursor to end
      if (inputRef.current) {
        inputRef.current.focus();
        requestAnimationFrame(() => {
          inputRef.current?.setSelectionRange(updatedTagline.length, updatedTagline.length);
        });
      }
    } catch (error) {
      console.error("[TagButton] Error updating tagline:", error);
      throw new Error("Failed to add hashtag. Please try again.");
    }
  }, [getValues, setValue, onChange, suggest, inputRef]);

  return (
    <div
      className="bg-input-primary relative -mt-[5px] rounded-b-md py-4"
      ref={(ref) => {
        if (ref) ref.onclick = () => document.querySelector("textarea")?.focus();
      }}
    >
      <button
        type="button"
        className={`text-tx-tertiary hover:text-tx-primary absolute bottom-2 left-2 rounded-full bg-transparent 
          px-1 transition-colors duration-300 ease-out`}
        onClick={appendHashToTagline}
      >
        # Hashtags
      </button>
    </div>
  );
});
